export const getRoutePath = (): string => process.env.CARVANA_APP_ROUTE_PATH || '/payments';
